import { BaseEntity } from '../../xform-compat';


export class PasswordExpiration implements BaseEntity {
  id: number;
  expirationDate: string;
  expirationDateUI: any;

  constructor (passwordExpiration: any = {}) {
    this.id = passwordExpiration.id || null;
    this.expirationDate = passwordExpiration.expirationDate || null;
    this.expirationDateUI = passwordExpiration.expirationDateUI || null;
  }
}
